import { Routes } from '@angular/router';
import { OverviewComponent } from './pages/overview/overview.component';
import { WiegungService } from './services/wiegung-service';
import { ErstwiegungWiegungService } from './services/erstwiegung-wiegung.service';
import { GesamtwiegungWiegungService } from './services/gesamtwiegung-wiegung.service';
import { InventurWiegungService } from './services/inventur-wiegung.service';
import { ZwischenwiegungWiegungService } from './services/zwischenwiegung-wiegung.service';
import { MateriallieferscheinretourWiegungService } from './services/materiallieferscheinretour-wiegung.service';
import { MateriallieferscheinWiegungService } from './services/materiallieferschein-wiegung.service';

export const wiegungRoutes: Routes = [
  { path: 'wiegung',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/wiegung.component'),
        children: [{
          path: '',
          component: OverviewComponent
        }]
      },
      {
        path: 'materiallieferschein',
        loadComponent: () => import('./pages/form/form.component'),
        providers: [
          {
            provide: WiegungService,
            useFactory: () => new MateriallieferscheinWiegungService()
          }
        ],
        data: { type: 'MATERIALLIEFERSCHEIN', showOrder: true, isMaterialRequired: true, showMaterialSelection: true }
      },
      {
        path: 'material-retour',
        loadComponent: () => import('./pages/form/form.component'),
        providers: [
          {
            provide: WiegungService,
            useFactory: () => new MateriallieferscheinretourWiegungService()
          }
        ],
        data: { type: 'MATERIALLIEFERSCHEIN_RETOUR', showOrder: true, isMaterialRequired: true, showMaterialSelection: true }
      },
      {
        path: 'zwischenwiegen',
        loadComponent: () => import('./pages/form/form.component'),
        providers: [
          {
            provide: WiegungService,
            useFactory: () => new ZwischenwiegungWiegungService()
          }
        ],
        data: {type: 'ZWISCHENWIEGEN', showOrder: false, isMaterialRequired: false, showMaterialSelection: false}
      },
      {
        path: 'inventur',
        loadComponent: () => import('./pages/form/form.component'),
        providers: [
          {
            provide: WiegungService,
            useFactory: () => new InventurWiegungService()
          }
        ],
        data: {type: 'INVENTUR', showOrder: false, isMaterialRequired: true, showMaterialSelection: true }
      },
      {
        path: 'erstwiegung',
        loadComponent: () => import('./pages/form/form.component'),
        providers: [
          {
            provide: WiegungService,
            useFactory: () => new ErstwiegungWiegungService()
          }
        ],
        data: {type: 'ERSTWIEGUNG', showOrder: true, isMaterialRequired: false, showMaterialSelection: false }
      },
      {
        path: 'gesamt',
        loadComponent: () => import('./pages/form/form.component'),
        providers: [
          {
            provide: WiegungService,
            useFactory: () => new GesamtwiegungWiegungService()
          }
        ],
        data: { type: 'GESAMTWIEGEN', showOrder: true, isMaterialRequired: false, showMaterialSelection: false }
      }
    ],
  },
]
